import React from 'react'

export default function PageNoteFound() {
  return (
    <div>
        <div className='mt-5'></div>
        <center>
        <h1>Page Not Found</h1>
        <p>Sorry, the page you're looking for doesn't exist.</p>
        </center>
        
    </div>
  )
}
